import { render, staticRenderFns } from "./FunctionalAreaElementExample.vue?vue&type=template&id=72d07412&scoped=true&"
import script from "./FunctionalAreaElementExample.vue?vue&type=script&lang=js&"
export * from "./FunctionalAreaElementExample.vue?vue&type=script&lang=js&"
import style0 from "./FunctionalAreaElementExample.vue?vue&type=style&index=0&id=72d07412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d07412",
  null
  
)

export default component.exports